// extracted by mini-css-extract-plugin
export default {"Volume":"Volume_Volume__W7tSg","VolumeKnob":"Volume_VolumeKnob__fd6uA","VolumeLabel":"Volume_VolumeLabel__EdjJg"};